var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _rect5, _rect6, _rect7, _rect8, _path5, _rect9, _rect0, _rect1, _rect10, _path6, _rect11, _rect12, _rect13, _rect14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleItemMultiplePrices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 122,
    viewBox: "0 0 162 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 161,
    height: 121,
    rx: 4.5,
    fill: "#F8F8F8",
    stroke: "#CCCCCC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 88,
    width: 40,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 95,
    width: 40,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 75,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#BBBBBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 19H21V64H66V19ZM64.0583 21.0254H23.0264V62.0879H64.0583V21.0254Z",
    fill: "#68C598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.063 50.2781L38.1472 36.9043L25.29 56.19H42.9247L42.8569 56.2868H60.8569L51.8569 43.4297L47.063 50.2781Z",
    fill: "#68C598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.488 39.5848C57.3614 39.5848 59.6908 37.2791 59.6908 34.435C59.6908 31.5908 57.3614 29.2852 54.488 29.2852C51.6145 29.2852 49.2852 31.5908 49.2852 34.435C49.2852 37.2791 51.6145 39.5848 54.488 39.5848Z",
    fill: "#68C598"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.171 16.7129H85.2469C83.6875 16.7129 82.4233 18.056 82.4233 19.7129V37.7129C82.4233 39.3697 83.6875 40.7129 85.2469 40.7129H148.171C149.731 40.7129 150.995 39.3697 150.995 37.7129V19.7129C150.995 18.056 149.731 16.7129 148.171 16.7129Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 123.572,
    y: 25.8555,
    width: 20,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 90.4287,
    y: 23,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 29.4316,
    width: 22,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 33,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.171 48.7129H85.2469C83.6875 48.7129 82.4233 50.056 82.4233 51.7129V69.7129C82.4233 71.3697 83.6875 72.7129 85.2469 72.7129H148.171C149.731 72.7129 150.995 71.3697 150.995 69.7129V51.7129C150.995 50.056 149.731 48.7129 148.171 48.7129Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 123.572,
    y: 57.8555,
    width: 20,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 90.4287,
    y: 55,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 61.4316,
    width: 22,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 65,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.171 80.7129H85.2469C83.6875 80.7129 82.4233 82.056 82.4233 83.7129V101.713C82.4233 103.37 83.6875 104.713 85.2469 104.713H148.171C149.731 104.713 150.995 103.37 150.995 101.713V83.7129C150.995 82.056 149.731 80.7129 148.171 80.7129Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 123.572,
    y: 89.8555,
    width: 20,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 90.4287,
    y: 87,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 93.4316,
    width: 22,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 97,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleItemMultiplePrices);
export default __webpack_public_path__ + "static/media/single-item-multiple-prices.e1a14166dc4bfe013babc01aa6e88478.svg";
export { ForwardRef as ReactComponent };